const config = {
    server: 'https://cagenlinea.colegiodearquitectos.org.gt'
};

export default config;